import * as React from "react";

import { Button } from "@/components/ui/button";

interface PartialErrorProps {
  failedSource: "owned" | "shared";
  onRetry: () => unknown;
}

export const DrivePartialError: React.FC<PartialErrorProps> = ({ failedSource, onRetry }) => (
  <div
    role="alert"
    className="flex flex-wrap items-center justify-between gap-3 rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950"
  >
    <span>
      {failedSource === "owned" ? "Your folders could not be loaded" : "Shared documents could not be loaded"}
    </span>
    <Button variant="outline" size="sm" onClick={onRetry}>
      Retry
    </Button>
  </div>
);

interface FatalErrorProps {
  onRetry?: () => unknown;
}

export const DriveFatalError: React.FC<FatalErrorProps> = ({ onRetry }) => (
  <div
    role="alert"
    className="flex min-h-56 flex-col items-center justify-center rounded-lg border border-red-200 bg-red-50 px-6 text-center text-red-950"
  >
    <p className="font-semibold">Unable to load documents</p>
    <p className="mt-2 max-w-lg text-sm text-red-800">Refresh the page or try again in a moment.</p>
    {onRetry && (
      <Button variant="outline" className="mt-4" onClick={onRetry}>
        Retry
      </Button>
    )}
  </div>
);

interface EmptyProps {
  query: string;
  canCreate: boolean;
  onClearSearch: () => void;
}

export const DriveEmptyState: React.FC<EmptyProps> = ({ query, canCreate, onClearSearch }) => (
  <div role="row" data-testid="drive-empty-row">
    <div role="cell" className="flex flex-col items-center justify-center px-6 py-12 text-center">
      <p className="text-midnight-blue font-semibold">
        {query ? "No documents match this search" : "No documents in this view"}
      </p>
      {query ? (
        <Button variant="outline" className="mt-4" onClick={onClearSearch}>
          Clear search
        </Button>
      ) : canCreate ? (
        <p className="mt-2 text-sm text-gray-500">Upload a document or create a folder to get started.</p>
      ) : null}
    </div>
  </div>
);
